import { lazy } from 'react';

const DocumentClassifierPage = lazy(() => import('@/pages/document-classifier/DocumentClassifierPage'));

export const documentClassifierRoutes = [
    {
        path: 'document-classifier',
        element: <DocumentClassifierPage />,
    },
];
